import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Section.css';

function getSectionClassName(colorScheme) {
  const classNameMap = {
    default: 'edu-section--default',
    red: 'edu-section--red',
    green: 'edu-section--green',
    blue: 'edu-section--blue',
    yellow: 'edu-section--yellow'
  };

  return classNameMap[colorScheme];
}

function Section(props) {
  const sectionClass = getSectionClassName(props.colorScheme);

  return (
    <section
      className={classNames(
        props.className,
        'edu-section',
        sectionClass,
        'clearfix'
      )}
    >
      {props.title ? (
        <h2 className="edu-section__title">{props.title}</h2>
      ) : null}
      <div className="edu-section__contents">{props.children}</div>
    </section>
  );
}

Section.defaultProps = {
  title: null,
  colorScheme: 'default',
  className: null
};

Section.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  colorScheme: PropTypes.oneOf(['default', 'red', 'green', 'blue', 'yellow']),
  children: PropTypes.node.isRequired
};

export default Section;



// WEBPACK FOOTER //
// ./src/components/edu/Section.js